<template>
    <!-- TODO css -->
    <modal @close="modals.productEdit = false">
        <h3>Edit {{ item.name }}</h3>
        <div class="large-form">
            <div class="form-line">
                <div id="form-field-name" class="form-field" style="width: 100%">
                    <label for="form-input-name">Product Name</label>
                    <input v-model="editItem.name" type="text" id="form-input-name" required="required" />
                </div>
            </div>
            <div class="form-line">
                <div id="form-field-slug" class="form-field" style="width: 100%; text-align: left;">
                    <label>Description</label>
                    <textarea v-model="editItem.description" rows="3"></textarea>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field">
                    <label>Status</label>
                    <select v-model="editItem.team_status">
                        <option value="active">Active</option>
                        <option value="paused">Paused</option>
                    </select>
                </div>
            </div>
            <div class="modal-errors">
                <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
            </div>
        </div>
        <div class="form-actions">
            <span class="ws-button ws-button-secondary" @click="modals.productEdit = false">CANCEL</span>
            <span class="ws-button ws-button-main" @click="update">UPDATE PRODUCT</span>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "ProductEditModal",
    components: {Modal},
    props: {
    },
    data() {
        return {
            editItem: {name:'', description:'', team_status: ''},
            errors: {},
        }
    },
    methods: {
        async update() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Name', value: this.editItem.name, rules: ['required', 'minLength:1'] },
                { name: 'Status', value: this.editItem.team_status, rules: ['required'] },
                { name: 'Description', value: this.editItem.description, rules: ['required'] },
            ]);
            if (Object.keys(this.errors).length) return;

            await this.dispatchWaitAndNotify('updateProduct', {productId: this.item.id, payload: this.editItem});
            this.$emit('updated');
        },
    },
    async mounted() {
        this.editItem.name = this.item.name;
        this.editItem.team_status = this.item.team_status;
        this.editItem.description = this.item.description;
    },
    computed: {
        item() {
            return this.$store.state.product.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>

<style scoped>

</style>